import { render, staticRenderFns } from "./UserTransferModal.vue?vue&type=template&id=5d16b8f6&scoped=true&"
import script from "./UserTransferModal.vue?vue&type=script&lang=js&"
export * from "./UserTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./UserTransferModal.vue?vue&type=style&index=0&id=5d16b8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d16b8f6",
  null
  
)

export default component.exports